<template>
  <div class="invite_wrap kefu-page">
    <div class="basic_wrap">
      <div class="red_top_bg page-top">
        <div
          class="back_left"
          @click="$router.back()"
        />
        <div class="big_tit">
          {{ $t('webindex.custserver') }}
        </div>
        <button
          type="button"
          class="back_right top-action"
          @click="$router.push('/user')"
        >
          <van-icon name="user-o" />
        </button>
      </div>

      <div
        v-if="data"
        class="service-list"
      >
        <a
          v-if="data.app_link"
          class="service-card"
          :href="data.app_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="brand-badge whatsapp">W</span>
          <span class="service-main">
            <strong>Whatsapp</strong>
            <small>{{ $t('webindex.chat') }}</small>
          </span>
          <span class="service-cta">
            {{ $t('webindex.chat') }}
          </span>
        </a>

        <a
          v-if="data.kefu_link"
          class="service-card"
          :href="data.kefu_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="brand-badge telegram">T</span>
          <span class="service-main">
            <strong>Telegram</strong>
            <small>{{ $t('webindex.chat') }}</small>
          </span>
          <span class="service-cta">
            {{ $t('webindex.chat') }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon);

export default {
	name: "Index",
	data() {
		return {
			handler: null,
			data: {},
		};
	},
	created() {
		this.$parent.footer("user");
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			var agent = localStorage.getItem("agent");
			Fetch("/index/webconfig", {
				agent: agent,
				type: "web",
			}).then(res => {
				this.data = res.data;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.kefu-page {
	min-height: 100vh;
	background: #f1f8f7;
	color: #123d42;
	padding-bottom: 80px;
	box-sizing: border-box;

	.basic_wrap {
		min-height: 100vh;
		background: #f1f8f7;
	}
}

.page-top {
	height: 44px;
	background: #063942;
	color: #fff;
	border-bottom: 1px solid #075e67;
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #fff;
	}
}

.top-action {
	position: absolute;
	top: 7px;
	right: 16px;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.14);
	color: #e3fbf8;
	font-size: 17px;
	padding: 0;
}

.service-list {
	padding: 18px 16px 0;
}

.service-card {
	min-height: 86px;
	margin-bottom: 14px;
	padding: 18px;
	display: flex;
	align-items: center;
	border-radius: 14px;
	border: 1px solid #c7e0dd;
	background: #fff;
	box-shadow: 0 8px 18px rgba(10, 73, 79, 0.08);
	text-decoration: none;
	box-sizing: border-box;
}

.brand-badge {
	width: 46px;
	height: 46px;
	flex: 0 0 46px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	color: #ffffff;
	font-size: 18px;
	font-weight: 700;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);
}

.brand-badge.whatsapp {
	background: #1fb65b;
}

.brand-badge.telegram {
	background: #2a9edb;
}

.service-main {
	min-width: 0;
	flex: 1;
	margin-left: 14px;
	display: flex;
	flex-direction: column;
}

.service-main strong {
	color: #074b53;
	font-size: 16px;
	font-weight: 700;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.service-main small {
	margin-top: 4px;
	color: #60797c;
	font-size: 12px;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.service-cta {
	flex: 0 0 auto;
	max-width: 96px;
	margin-left: 12px;
	padding: 7px 14px;
	border-radius: 16px;
	background: linear-gradient(135deg, #063942 0%, #0c8188 100%);
	color: #fff;
	font-size: 12px;
	font-weight: 700;
	line-height: 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	box-sizing: border-box;
}

@media screen and (max-width: 374px) {
	.service-list {
		padding-right: 12px;
		padding-left: 12px;
	}

	.service-card {
		padding-right: 14px;
		padding-left: 14px;
	}

	.service-cta {
		max-width: 82px;
		padding-right: 12px;
		padding-left: 12px;
	}
}
</style>
